import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { CarsState } from '../../types';

import { getCarsLocationSharing } from '../operations/getCarsLocationSharing';

import { STATUS_LOADING } from 'common/constants';

export const setCarsLocationSharing = (builder: ActionReducerMapBuilder<CarsState>) => builder
  .addCase(getCarsLocationSharing.pending, (state) => {
    state.locationSharing.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getCarsLocationSharing.fulfilled, (state, { payload }) => {
    state.locationSharing.loadingStatus = STATUS_LOADING.done;
    state.locationSharing.data = payload;
  })
  .addCase(getCarsLocationSharing.rejected, (state) => {
    state.locationSharing.loadingStatus = STATUS_LOADING.error;
  });
